import React, { useEffect, useState } from "react";
import Styles from "./AboutUs.module.scss";
import { appLevelConstants } from "../../constants/AppLevelConstants";
import AOS from "aos";
import { urls } from "../../utils/urls";
import bm from "../100-board-members/BoardMembers100.module.scss";

export default function AboutUs() {
  useEffect(() => {
    AOS.init();
  }, []);

  const [profession, setProfession] = useState("CEOs");
  const getNextProfession = (currentProfession) => {
    switch (currentProfession) {
      case "CEOs":
        return "CHRO";
      case "CHRO":
        return "COOs";
      case "COOs":
        return "CFOs";
      case "CFOs":
        return "CTOs";
      case "CTOs":
        return "CxOs";
      case "CxOs":
        return "Entrepreneurs";
      case "Entrepreneurs":
        return "Doctors";
      case "Doctors":
        return "Lawyers";
      default:
        return "CEOs";
    }
  };

  useEffect(() => {
    const toggleInterval = setInterval(() => {
      setProfession((prev) => getNextProfession(prev));
    }, 2000);
    return () => clearInterval(toggleInterval);
  }, []);

  const { aboutUs: a } = appLevelConstants;

  return (
    <>
      <section className={bm.hero}>
        <div className={bm["hero-overlay"]} aria-hidden />
        <div className={bm["hero-inner"]}>
          <div className={bm["hero-content"]}>
            <div className={bm["hero-eyebrow"]}>About us</div>
            <div className={bm["hero-brand"]}>Iron Lady</div>
            <div className={bm["hero-tagline"]}>
              Leadership
              <span>at scale.</span>
            </div>
            <p className={bm["hero-sub"]}>
              India’s platform for women reaching the top — through high-impact programs, a strength-obsessed community, and outcomes you can measure.
            </p>
          </div>
        </div>
      </section>

      <section className={bm["video-section"]} aria-label="About Iron Lady video">
        <div className={bm["video-wrap"]}>
          <video
            className={Styles.aboutVideo}
            controls
            playsInline
            poster={urls.aboutUsThumbneil}
            data-aos="fade-up"
            data-aos-duration="800"
          >
            <source src={urls.aboutUsVideo} type="video/mp4" />
          </video>
        </div>
      </section>

      <section className={`${bm.authority} ${Styles.aboutAuthority}`}>
        <div className={`${bm["authority-grid"]} ${Styles.aboutAuthorityGrid}`}>
          <div className={`${bm["authority-left"]} ${Styles.aboutAuthorityLeft}`}>
            <span className={`${bm.eyebrow} ${Styles.aboutEyebrow}`}>Who we are</span>
            <h2>The destination for women who intend to lead.</h2>
            <div className={Styles.aboutNarrative}>
              <p>
                <strong className={Styles.brandLead}>{a.mainContent}</strong>
                {a.mainContent1}
              </p>
              <p>{a.mainContent2}</p>
            </div>
          </div>
          <div className={`${bm["authority-right"]} ${Styles.aboutAuthorityRight}`}>
            <div className={Styles.aboutHighlightBox} data-aos="fade-up" data-aos-duration="800">
              <p className={Styles.aboutHighlightLine}>
                {a.mainContent3}
                <span className={Styles.profession}>{profession}</span>
                {a.mainContent4}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`${bm.breakthrough} ${Styles.tedxSection}`}
        aria-label="Founder spotlight — TEDx"
      >
        <div className={Styles.tedxCard} data-aos="fade-up" data-aos-duration="800">
          <div className={Styles.tedxRail} aria-hidden="true" />
          <div className={Styles.tedxCardBody}>
            <span className={Styles.tedxEyebrow}>Founder spotlight · TEDx</span>
            <blockquote className={Styles.tedxQuote}>
              <span className={Styles.tedxQuoteMark} aria-hidden="true">
                &ldquo;
              </span>
              <span className={Styles.tedxQuoteText}>{a.mainContent7}</span>
            </blockquote>
          </div>
        </div>
      </section>
    </>
  );
}
